import styled from 'styled-components';
import {
    Heading, Paragraph, spaceMixin, token,
} from '@zillow/constellation';

export const StyledCenteredParagraph = styled(Paragraph)`
    text-align: center;
    max-width: 450px;
`;

export const StyledHeading = styled(Heading)`
    font-size: 20px;
`;

export const StyledBar = styled.div`
    border: 1px solid ${token('colors.yellow300')};
    width: 100%;
    max-width: 142px;
    margin: ${spaceMixin('md')} auto ${spaceMixin('lg')} auto;
`;
